import { FETCH_PRODUCTION_SMELTERS_DATA } from '../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_PRODUCTION_SMELTERS_DATA:
			return action.payload;
		default:
			return state;
	}
};
